import { cn } from "@sylviq/ui-react-web/lib/cn";
import { forwardRef, type SelectHTMLAttributes } from "react";

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, "onChange" | "value"> {
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

/**
 * Rounded native select. Pill shape by default (override with
 * `--select-radius` or className); colors/focus from theme tokens.
 * Every visual is overridable — this ships production-ready defaults only.
 */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, options, value, onChange, placeholder = "Select…", "aria-label": ariaLabel, ...props }, ref) => (
    <select
      ref={ref}
      aria-label={ariaLabel}
      className={cn("select", className)}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      {...props}
    >
      <option value="">{placeholder}</option>
      {options.map((o) => (
        <option key={o.value} value={o.value} disabled={o.disabled}>
          {o.label}
        </option>
      ))}
    </select>
  ),
);

Select.displayName = "Select";
